import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Component that automatically initiates wizard on first visit
 * to authenticated users who are coaches/schools
 */
export const WizardInitializer: React.FC = () => {
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    if (
      isAuthenticated &&
      user &&
      !user.is_wizard_disable &&
      !user.hasCreatedEvent &&
      user.is_active &&
      (!user.hasCreatedCategory || !user.hasCreatedStudent)
    ) {
      // Only show wizard for coaches and schools, not students/parents
      const isCoach = user.account_type === 'C';
      const isSchool = user.account_type === 'S';
      
      if (isCoach || isSchool) {
        // Check if wizard has ever been started
        const wizardStarted = localStorage.getItem('wizard-started');
        
        if (!wizardStarted) {
          // First time - start the wizard
          localStorage.setItem('wizard-step', '0');
          localStorage.setItem('wizard-active', 'true');
          localStorage.setItem('wizard-started', 'true');
          window.dispatchEvent(new Event('wizard-state-changed'));
        }
      }
    }
  }, [isAuthenticated, user]);

  return null;
};
